//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapActions, mapGetters} from "vuex";
import { getCartFromLocalStorage } from '~/utils/cart-util';
import Switcher from '~/components/Switcher';

export default {
  layout: 'full',
  head: {
    title: 'Qubino',
    description: ''
  },
  mounted() {
    this.$gtm.push({
      routeName: this.$route.name,
      pageType: 'PageView',
      pageUrl: this.$router.options.base + this.$route.fullPath.replace('/', ''),
      pageTitle: (typeof document !== 'undefined' && document.title) || '',
      ecommCategory: 'Home',
      event: 'nuxtRoute'
    });
    this.$gtm.push({
      'event': 'checkout',
      'ecommerce': {
        'checkout': {
          'actionField': {'step': 1, 'name': 'Home'}
        }
      }
    });
  },
  async created() {
    this.getCartItems();
    this.getSelectedProducts();
    this.unsetEditingIndex();
    await this.setPartner();
    this.$nextTick(() => {
      this.scrollableEnabled = true;
    })
  },
  components: { Switcher },
  data: () => {
    let slideNotification = JSON.parse(sessionStorage.getItem('slideNotification'));
    if (slideNotification === null) {
      slideNotification = true;
    }
    return {
      awnings: false,
      windows: false,
      spaAndPool: false,
      shades: false,
      irrigation: false,
      householdAppliances: false,
      doors: false,
      safetyAndSecurity: false,
      domesticWater: false,
      ventilation: false,
      heating: false,
      it: false,
      lighting: false,
      energyMetering: false,
      cartAmount: 0,
      mouseDown: false,
      startX: null,
      scrollLeft: null,
      slideNotification: slideNotification,
      scrollMove: 250,
      scrollableEnabled: false,
      scrollingF: false,
    }
  },
  computed: {
    ...mapGetters(['getPartner'])
  },
  methods: {
    ...mapActions(['getCart', 'unsetEditingIndex', 'setPartner']),
    addToCartDemo(type) {
      this.cartAmount = this[type] ? this.cartAmount - 1 : this.cartAmount + 1;
      this[type] = !this[type];
    },
    getCartItems() {
      const cart = getCartFromLocalStorage();
      this.cartAmount = cart && cart.length || 0;
    },
    getSelectedProducts() {
      const cart = getCartFromLocalStorage();
      if (cart && Array.isArray(cart)) {
        this.awnings = !!(cart && cart.find(x => x.key === 'awnings'));
        this.windows = !!(cart && cart.find(x => x.key === 'windows'));
        this.shades = !!(cart && cart.find(x => x.key === 'shades'));
        this.irrigation = !!(cart && cart.find(x => x.key === 'irrigation'));
        this.householdAppliances = !!(cart && cart.find(x => x.key === 'household-appliances'));
        this.doors = !!(cart && cart.find(x => x.key === 'doors'));
        this.domesticWater = !!(cart && cart.find(x => x.key === 'domestic-water'));
        this.ventilation = !!(cart && cart.find(x => x.key === 'ventilation'));
        this.heating = !!(cart && cart.find(x => x.key === 'heating'));
        this.spaAndPool = !!(cart && cart.find(x => x.key === 'spa-and-pool'));
        this.it = !!(cart && cart.find(x => x.key === 'it-audio-video'));
        this.lighting = !!(cart && cart.find(x => x.key === 'lighting'));
        this.energyMetering = !!(cart && cart.find(x => x.key === 'energy-metering'));
        this.safetyAndSecurity = !!(cart && cart.find(x => x.key === 'safety-and-security'));
      } else if (cart && typeof cart === 'object') {
        this.cartAmount = 1;
        this[cart.key] = true;
      }
    },
    startDrag(e) {
      this.mouseDown = true;
      this.startX = e.pageX - this.$refs.houseWrapper.offsetLeft;
      this.scrollLeft = this.$refs.houseWrapper.scrollLeft;
    },
    stopDrag() {
      this.mouseDown = false;
      this.reCheckScrollButtons();
    },
    moveDrag(e) {
      e.preventDefault();
      if(!this.mouseDown) { return; }
      const x = e.pageX - this.$refs.houseWrapper.offsetLeft;
      const scroll = x - this.startX;
      this.$refs.houseWrapper.scrollLeft = this.scrollLeft - scroll;
    },
    hideSlideNotification() {
      this.slideNotification = false;
      sessionStorage.setItem('slideNotification', false);
    },
    getIcon(category) {
      if (category) {
        return 'check'
      }
      return 'plus'
    },
    scrollToLeft() {
      this.scrollingF = true;
      this.$nextTick(() => {
        if (this.$refs.houseWrapper.scrollLeft > 0) {
          this.$refs.houseWrapper.scrollLeft -= (this.scrollMove + (this.$refs.houseWrapper.scrollLeft % this.scrollMove));
        }
        this.scrollingF = false;
        this.$nextTick(() => {
          this.reCheckScrollButtons();
        })
      });
      // needs to check almost immediately and after scroll is done
      setTimeout(() => {
        this.reCheckScrollButtons();
      }, 50);
      setTimeout(() => {
        this.reCheckScrollButtons();
      }, 500);
    },
    scrollToRight() {
      this.scrollingF = true;
      this.$nextTick(() => {
        if (this.$refs.houseWrapper.scrollLeft + this.$refs.houseWrapper.offsetWidth < this.$refs.houseWrapper.scrollWidth) {
          this.$refs.houseWrapper.scrollLeft += (this.scrollMove - (this.$refs.houseWrapper.scrollLeft % this.scrollMove));
        }
        this.scrollingF = false;
        this.$nextTick(() => {
          this.reCheckScrollButtons();
        })
      });
      // needs to check almost immediately and after scroll is done
      setTimeout(() => {
        this.reCheckScrollButtons();
      }, 50);
      setTimeout(() => {
        this.reCheckScrollButtons();
      }, 500);
    },
    reCheckScrollButtons() {
      this.$nextTick(() => {
        this.scrollableEnabled = false;
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.scrollableEnabled = true;
          });
        });
      })
    },
    scrollableLeft() {
      if (!this.scrollableEnabled) {
        return false;
      }
      return this.$refs.houseWrapper.scrollLeft > 0;
    },
    scrollableRight() {
      if (!this.scrollableEnabled) {
        return false;
      }
      return this.$refs.houseWrapper.scrollLeft + this.$refs.houseWrapper.offsetWidth < this.$refs.houseWrapper.scrollWidth;
    }
  }
}
